import React from "react";
import Lottie from "lottie-react";
import { ShinyText } from "./Home";
import DownloadButton from "../../component/DownloadButton/DownloadButton";
import PersonalDictionary from "../../Asset/json/Personal Dictionary.json";
import { useInView } from "react-intersection-observer";

const PersonalDictionarySection = () => {
  const { ref: videoRef, inView: videoView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: headingRef, inView: headingView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: buttonRef, inView: buttonView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  return (
    <div className="flex md:flex-row flex-col items-center md:gap-2 gap-10 xl:pt-10 lg:pt-8 md:pt-6 xl:pb-10 lg:pb-8 md:pb-6 lg:px-10 md:px-6 z-[5] bg-white ">
      <div className=" flex-1 flex flex-col md:items-start items-center xl:gap-5 lg:gap-4 gap-3">
        <div
          ref={headingRef}
          className={` ${
            headingView
              ? `animate-slideUp z-[3] anim-preserve`
              : "opacity-0 z-0"
          } xl:text-[3.125rem] lg:text-[2.8rem] md:text-[2.4rem] text-[2.625rem] md:text-left text-center leading-tight  font-jakarta font-bold`}
        >
          <ShinyText
            text="Personal Dictionary "
            speed={5}
            className="custom-class text-wrap"
          />
          That Knows Your Words
        </div>
        <div className=" xl:text-[1.438rem] z-[4] relative bg-white lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] md:text-left text-center  leading-snug text-[#00000099] font-inter">
          Add names, terms, or custom spellings to your personal{" "}
          <br className="lg:flex hidden" /> dictionary so Zero Typing always
          gets it right. No more <br className="lg:flex hidden" /> awkward typos
          or missed details.
        </div>
        <DownloadButton ref={buttonRef} view={buttonView} />
      </div>
      <div className=" flex-1 flex justify-center items-center">
        {/* <div
          ref={videoRef}
          className={`lg:w-[85%] md:w-[90%] w-full xl:rounded-3xl rounded-2xl overflow-hidden transition-opacity duration-500 ${
            videoView ? `animate-slideUp` : "opacity-0"
          }`}
        >
          <Lottie
            animationData={PersonalDictionary}
            loop
            style={{ width: "100%" }}
          />
        </div> */}
        <video
          ref={videoRef}
          className={`${
            videoView ? `animate-slideUp z-[3] anim-preserve` : "opacity-0 z-0"
          }  lg:w-[85%] md:w-[90%] w-full xl:rounded-3xl rounded-2xl `}
          src="https://pub-25f4599302a64a3dab9e149b2b5f9a0f.r2.dev/videos/Personal%20Dictionary.mp4"
          autoPlay
          loop
          muted
          playsInline
          webkit-playsinline="true"
          preload="metadata"
        />
      </div>
    </div>
  );
};

export default PersonalDictionarySection;
